import { render } from "./FormulairePaiement.vue?vue&type=template&id=a4f4fd34"
import script from "./FormulairePaiement.vue?vue&type=script&lang=js"
export * from "./FormulairePaiement.vue?vue&type=script&lang=js"

import "./FormulairePaiement.vue?vue&type=style&index=0&id=a4f4fd34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__